import authentication from "./authentication";
import shallowRoutes from "./shallowRoutes";
import errors from "./errors";
import campaigns from "./campaigns";
import validations from "./validations";
import reports from "./reports";
import partners from "./partners";
import notifications from "./notifications";
import teamManagement from "./teamManagement";
import advertisers from "./advertisers";
import loyaltyProgram from "./loyaltyProgram";
import agencies from "./agencies";
import accountSettings from "./accountSettings";
import receivables from "./receivables";
import payments from "./payments";
import extrasAndDeductions from "./extrasAndDeductions";
import releaseNotes from "./releaseNotes"
import targets from "./targets"

export default [
  {
    path: "/",
    name: "home-page",
    component: () => import(/* webpackChunkName: "Home" */ "@/views/Home.vue"),
    meta: {
      requireAuth: true,
      title: "home",
      entityName: "home",
    },
  },
  ...authentication,
  ...shallowRoutes,
  ...campaigns,
  ...validations,
  ...reports,
  ...partners,
  ...notifications,
  ...teamManagement,
  ...advertisers,
  ...agencies,
  ...loyaltyProgram,
  ...accountSettings,
  ...receivables,
  ...payments,
  ...extrasAndDeductions,
  ...errors,
  ...releaseNotes,
  ...targets,
]
